import { jsx } from "react/jsx-runtime";
import { useRicosTheme } from "../../theme/ricos-theme-utils.js";
import RicosViewer from "../ricos-viewer/ricos-viewer.js";
import styles from "./field-description-wut.module.scss";
const RICOS_THEME = {
  customStyles: {
    p: {
      fontSize: "var(--wix-forms-formInputNoteFont-size)",
      fontFamily: "var(--wix-forms-formInputNoteFont-family)",
      color: "rgb(var(--wix-forms-formInputNoteColor, 0,0,0))"
    }
  }
};
const FieldDescriptionWUT = ({
  description,
  id
}) => {
  const customTheme = useRicosTheme(RICOS_THEME);
  return description ? /* @__PURE__ */ jsx("div", { className: styles.description, id, children: /* @__PURE__ */ jsx(RicosViewer, { content: description, customTheme }) }) : null;
};
export {
  FieldDescriptionWUT
};
//# sourceMappingURL=field-description-wut.js.map
